import script from "./ErrorsAndWarningsUpdate.vue?vue&type=script&setup=true&lang=ts"
export * from "./ErrorsAndWarningsUpdate.vue?vue&type=script&setup=true&lang=ts"

import "./ErrorsAndWarningsUpdate.vue?vue&type=style&index=0&id=1b7a040a&lang=scss"

const __exports__ = script;

export default __exports__